import { render, staticRenderFns } from "./GouyaoDetail.vue?vue&type=template&id=35f72f82&scoped=true"
import script from "./GouyaoDetail.vue?vue&type=script&lang=js"
export * from "./GouyaoDetail.vue?vue&type=script&lang=js"
import style0 from "./GouyaoDetail.vue?vue&type=style&index=0&id=35f72f82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f72f82",
  null
  
)

export default component.exports